//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/Expression.js";
let d=[[[1,"AngularDelta",0,"Expression",0],[0,"ClockType",1,0],[1,"Direction1Delta",0,"Expression",0],[1,"Direction2Delta",0,"Expression",0],[1,"Motion",0,"GeometricUtilities.ModlMotion",0],[1,"RadialDelta",0,"Expression",0]],[[["index1","index2"],"AddInstance",{},2,0],[["index1","index2"],"RemoveInstance",{},2,0]],[]];
SPLM.GeometricUtilities.PatternClockingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.PatternClockingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.PatternClockingBuilder.ClockingType = Object.freeze({
    "WithinPatternDefinitionLinear" : "WithinPatternDefinitionLinear", "WithinPatternDefinitionCircular" : "WithinPatternDefinitionCircular", "UserDefined" : "UserDefined", "WithinPatternDefinitionAxial" : "WithinPatternDefinitionAxial"});

export default SPLM;